import React from "react";
import SearchBaseComponent from "../bases/SearchBaseComponent/SearchBaseComponent";
export default function SearchPage() {
    return (
        <div className="pp-page">
            <div className="pp-page-header d-flex align-items-center justify-content-between">
                <h1 className="pp-page-title">Search</h1>
                <div className="pp-page-actions"></div>
            </div>
            <SearchBaseComponent />
        </div>
    );
}
